<template>
<div>
  <!-- <div class="socialLearning_social-learning-detail" > -->
  <div class="socialLearning_social-learning-detail" style="position: absolute;z-index: 9999;background: var(--DocumentWhite);top: 0px;width: 100%;height: 100%;">
    <div class="sm_star">
      <!-- header -->
      <div class="sm_header">
        <h1>Forum</h1>
        <button class="back_btn mdc-button" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">
          <i class="material-icons">arrow_back</i>
        </button>
        <div class="more-btn-parent-div mdc-button">
          <button class="more_btn mdc-button" @click="toggleMore" @keypress="toggleMore" tabindex="0">
            <i class="material-icons">more_vert</i>
          </button>

          <!-- 수정삭제신고 -->
          <div class="more_box" v-if="detail" style="display:none">
            <a
              class="cursor-pointer"
              v-if="!detail.owner"
              @click="askForReport(detail.report)" @keypress="askForReport(detail.report)" tabindex="0"
            >{{ $t("1446") }}</a>
            <a
              class="cursor-pointer" tabindex="0"
              @click="$router.push('/forums/'+detail.id+'/edit');"
              @keypress="$router.push('/forums/'+detail.id+'/edit');"
              v-if="detail.owner"
            >{{ $t("1448") }}</a>
            <a class="cursor-pointer" v-if="detail.owner" @click="askForDelete" @keypress="askForDelete" tabindex="0">
              {{
              $t("1449")
              }}
            </a>
          </div>
        </div>
        <!--// 수정삭제신고 -->
        <!-- {{ detail}} -->
      </div>
      <!-- //header -->

      <!-- content -->
      <div class="sm_wrap" v-if="detail" >
        <div class="sm_list view">
          <div class="sm_list_box" >
            <!-- list-->
            <div class="list_box">
              <!-- userbox -->
              <div class="user_box">
                <div class="user_img">
                  <img
                    :src="
                      detail.auditor &&
                      detail.auditor.register &&
                      detail.auditor.register.profile
                        ? detail.auditor.register.profile
                        : '/images/user.png'
                    "
                  />
                </div>
                <div class="user_txt">
                  <p class="name">{{ detail.auditor?detail.auditor.register.name.fullName:'' }}</p>
                  <p class="date">
                    {{ detail.auditor?detail.auditor.register.storeName:'' }} |
                    {{ detail.auditor?detail.auditor.register.responsibilityName:'' }}
                  </p>
                </div>

                <div class="user_date">
                  {{
                  $moment(detail.auditor?detail.auditor.register.time:'').format("L")
                  }}
                </div>
              </div>
              <!-- //userbox -->

              <div class="user_con">
                {{ detail.contents.subject }}
                <br />
                <span v-html="detail.contents.body"></span>
              </div>

              <div class="user_tag">
                <span v-for="(tag, i) in detail.tags" :key="i">#{{ tag.name }}</span>
              </div>

              <div class="user_imgList view">
                <a
                  href="javascript:void(0)"
                  v-for="(img, i) in detail.contents.images"
                  :key="i"
                  @click="fileDisply(img)" tabindex="0"
                >
                  <img :src="img.resourceUri" :alt="img.originalName" />
                </a>
                <a href="javascript:void(null)" @click="fileDisply(detail.contents.video)" @keypress="fileDisply(detail.contents.video)" tabindex="0">
                  <video-player
                    class="video-player-box"
                    v-if="detail.contents.video && detail.contents.video.resourceUri"
                    :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: detail.contents.video.contentType, src: detail.contents.video.resourceUri }], height: 100, width:120}"
                    :playsinline="true"
                  />
                </a>
              </div>

              <div class="user_opt">
                {{ $t("1437", { str: detail.likesCount }) }} &nbsp;&nbsp;
                {{ $t("1438", { str: detail.commentCount }) }}
                <span
                  class="right"
                >
                  {{
                  $t("1439", { str: detail.viewCount })
                  }}
                </span>
              </div>

              <div class="list_btn">
                <a
                  @click="patchLikeState(detail.id, detail.like)" @keypress="patchLikeState(detail.id, detail.like)" tabindex="0"
                  class="like"
                  :class="{ on: detail.like }"
                >{{ $t("1440") }}</a>
                <a class="reply">{{ $t("1441") }}</a>
              </div>
              

              <!-- reply -->
              <div class="reply_wrap" v-for="comment in comments" :key="comment.id">
                <div class="reply_box">
                  <!-- userbox -->
                  <div class="user_box">
                    <div class="user_img">
                      <img
                        :src="comment.auditor.register.profile"
                        :alt="comment.auditor.register.name.fullName"
                      />
                    </div>
                    <div class="user_txt">
                      <p class="name">{{ comment.auditor.register.name.fullName }}</p>
                      <p
                        class="date"
                      >{{ comment.auditor.register.storeName }} | {{ comment.auditor.register.responsibilityName }}</p>
                    </div>

                    <div
                      class="user_date"
                    >{{ $moment(comment.auditor.register.time).format("L") }}</div>
                    <div class="more-btn-parent-div">
                      <button type="button" class="more_btn mdc-button" @click="toggleMore" @keypress="toggleMore" tabindex="0">more</button>
                      <div class="more_box box-absolute">
                        <!-- report comment -->
                        <a
                          class="cursor-pointer"
                          v-if="!comment.owner"
                          @click="reportComment(comment.id, comment.report)" @keypress="reportComment(comment.id, comment.report)" tabindex="0"
                        >{{ $t("1446") }}</a>
                        <!-- modify comment -->
                        <a
                          class="cursor-pointer"
                          v-if="comment.owner"
                          @click="toggleMore" @keypress="toggleMore" tabindex="0"
                        >{{ $t("1448") }}</a>
                        <!-- delete comment -->
                        <a
                          class="cursor-pointer"
                          v-if="comment.owner"
                          @click="deleteComment(comment.id)" @keypress="deleteComment(comment.id)" tabindex="0"
                        >{{ $t("1449") }}</a>
                      </div>
                    </div>
                  </div>
                  <!-- //userbox -->

                  <div class="user_con" v-html="comment.contents"></div>

                  <div class="user_imgList reply" v-if="comment.images.length" style="position:relative">
                    <a
                      href="javascript:void(null)"
                      v-for="(img, i) in comment.images"
                      :key="i"
                      @click="fileDisply(img)" @keypress="fileDisply(img)" tabindex="0"
                      style="z-index:99"
                    >
                      <img
                        @click="fileDisply(img.resourceUri,false)" @keypress="fileDisply(img.resourceUri,false)" tabindex="0"
                        v-if="getType(img.contentType) === 'image'"
                        :src="img.resourceUri"
                        :alt="img.originalName"
                      />
                      <video-player
                        class="video-player-box"
                        v-if="getType(img.contentType) === 'video'"
                        ref="videoPlayer"
                        :options="getPayerOption(img)"
                        :playsinline="true"
                        customEventName="customstatechangedeventname"
                      />
                      <div style="position:absolute; background-color:transparent; width:120px;height:100px; margin-top: -100px;z-index:999"></div>
                    </a>
                    

                  </div>

                  <div class="list_btn">
                    <a
                      @click="likeComment(comment.id, comment.likes)" @keypress="likeComment(comment.id, comment.likes)" tabindex="0"
                      class="like"
                      :class="{ on: comment.likes }"
                    >{{ $t("1443", {str: comment.likesCount}) }}</a>
                    <a
                      href="javascript:void(null)"
                      class="reply"
                      @click="toggleReply(comment.id)" tabindex="0"
                    >{{ $t('1444') }}</a>
                  </div>

                  <div class="d-none" :id="`commentInput_${comment.id}`">
                    <div class="comment_area reply_area">
                      <!--<button type="button" class="picture_btn">사진 업로드</button>-->
                      <button type="button" class="video_btn mdc-button" @click="openFileUpload(false)" @keypress="openFileUpload(false)" tabindex="0"></button>
                      <button
                        type="button"
                        class="comment_btn mdc-button"
                        @click="submitReply(comment.id, $event)" @keypress="submitReply(comment.id, $event)" tabindex="0"
                      >댓글 업로드</button>

                      <textarea class="comment_textarea mdc-text-field__input" :placeholder="$t('1445')"></textarea>
                    </div>
                  </div>

                  <!-- rereply -->
                  <div class="reply_box" v-for="reply in comment.children" :key="reply.id">
                    <!-- userbox -->
                    <div class="user_box">
                      <div class="user_img">
                        <img
                          :src="reply.auditor.register.profile"
                          :alt="reply.auditor.register.name.fullName"
                        />
                      </div>
                      <div class="user_txt">
                        <p class="name">{{ reply.auditor.register.name.fullName }}</p>
                        <p
                          class="date"
                        >{{ reply.auditor.register.storeName }} | {{ reply.auditor.register.responsibilityName }}</p>
                      </div>

                      <div
                        class="user_date"
                      >{{ $moment(reply.auditor.register.time).format("L") }}</div>
                      <button type="button" class="more_btn mdc-button">more</button>
                    </div>
                    <!-- //userbox -->

                    <div class="user_con" v-html="reply.contents">
                      <!-- <span class="em">홍길동</span> -->
                    </div>

                    <div class="user_imgList reply" v-for="(img, i) in reply.images" :key="i">
                      <a href="javascript:void(null)">
                        <img
                          v-if="getType(img.contentType) === 'image'"
                          :src="img.resourceUri"
                          :alt="img.originalName"
                        />
                        <video-player
                          class="video-player-box"
                          v-if="getType(img.contentType) === 'video'"
                          :options="getPayerOption(img)"
                          :playsinline="true"
                        />
                      </a>
                    </div>

                    <div class="list_btn">
                      <a
                        href="javascript:void(null)"
                        @click="likeReply(reply.id, reply.likes, comment.id)" @keypress="likeReply(reply.id, reply.likes, comment.id)" tabindex="0"
                        class="like"
                        :class="{ on: reply.likes }"
                      >{{ $t("1443", {str: reply.likesCount}) }}</a>
                    </div>
                  </div>
                  <!-- //rereply -->
                </div>
              </div>
              <!-- //reply -->
                  
                  <div class="comment_box" style="bottom: 50px;" v-if="form.images.length >0" >
                    
                      <div class="post-video position-relative mgr-32 mgb-32" v-for="(img, i) in form.images" :key="i" style="width: 120px;" >
                        <img :src="img.resourceUri" :alt="img.originalName" style="width: 120px;" v-if="getType(img.contentType) == 'image' " />
                        <video-player
                        v-if="getType(img.contentType) == 'video'"
                        class="video-player-box"
                        :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: img.contentType, src: img.resourceUri }], height: 100, width:120}"
                        :playsinline="true"
                      />

                        <span tabindex="0" @click="form.images.splice(i, 1)" @keypress="form.images.splice(i, 1)" class="remove-img remove-image-new position-absolute t-color-white"><img src="/images/close.svg" style="width: 20px;}" /></span>
                      </div>

                    <!-- <div class="post-video position-relative mgr-32 mgb-32" v-if="form.images.length > 0 && getType(form.images[0].contentType) == 'video'" style="width: 120px;" >
                      <video-player
                        class="video-player-box"
                        :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: form.images[0].contentType, src: form.images[0].resourceUri }], height: 100, width:120}"
                        :playsinline="true"
                      />

                      <span @click="resetVideo" class="remove-img remove-image-new position-absolute t-color-white"><img src="/images/close.svg" style="width: 20px;}" /></span>

                    </div> -->
                  </div>


              </div>

              <!-- comment -->
              <div class="comment_box">
                <div class="comment_area">
                  <input
                    type="file"
                    id="commentFileUpload"
                    accept="image/jpeg, image/png, video/mp4"
                    @change="uploadFile"
                    class="d-none"
                  />
                  <!--<button type="button" class="picture_btn">사진 업로드</button>-->
                  <button type="button" class="video_btn mdc-button" @click="openFileUpload(true)" @keypress="openFileUpload(true)" tabindex="0"></button>
                  <button type="button" class="comment_btn mdc-button" @click="submitComment" @keypress="submitComment" tabindex="0">댓글 업로드</button>

                  <textarea
                    class="comment_textarea"
                    v-model="form.contents"
                    :placeholder="$t('1445')"
                  ></textarea>
                </div>
              </div>
            </div>
            <!-- //list-->

            
          </div>
        </div>
      </div>    

      <!-- //content -->
    </div>
    <infinite-loading @infinite="getComments" :identifier="infiniteId"  spinner="spiral">
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
    </infinite-loading>
 </div>
</template>

<script>
import socialApi from "@/api/forumApi.js";
import InfiniteLoading from "vue-infinite-loading";

// require styles
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import {MDCRipple} from '@material/ripple'

export default {
  components: {
    InfiniteLoading,
    videoPlayer,
  },
  beforeMount() {
    this.setDetail();
    this.getComments();
  },
  data() {
    return {
      detail: null,
      comments: [],
      form: {
        contents: null,
        images: [],
      },
      replyImg: [],
      isComment: true,
      isNoData: false,
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
    };
  },
   watch: {
    $route(to, from) {
      this.initData();
      
    }
  },
  mounted() {
        this.setMaterialUi()
    },
  methods: {
    initData() {
      this.comments = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    resetVideo() {
      this.form.images = Array();
    },
    getPayerOption(img) {
      return {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri,
          },
        ],
        height: 100,
        width: 120,
      };
    },
    getType(contentType) {
      return contentType.split("/")[0];
    },
    submitReply(originId, evt) {
      // search for reply comment
      let contents = evt.target
        .closest(".reply_area")
        .querySelector(".comment_textarea")
        .value.trim();
      if (!contents) return;

      this.$showLoading();
      // call API to add reply
      socialApi
        .postReply("SNS", this.detail.id, originId, {
          contents: contents,
          images: this.replyImg,
        })
        .then((response) => {
          this.$hideLoading();
          evt.target
            .closest(".reply_area")
            .querySelector(".comment_textarea").value = null;
          this.toggleReply(originId);
          this.replyImg = [];
          // add reply into parent
          for (let c in this.comments) {
            if (this.comments[c].id == originId) {
              this.comments[c].children.push(response.data.data);
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    uploadFile(evt) {
      if (!evt.target.files[0]) return;
      this.$showLoading();
      socialApi
        .upload(evt.target.files[0])
        .then((response) => {
          // check if Image need to add into reply or comment
          if (this.isComment) this.form.images.push(response.data.data[0]);
          else this.replyImg.push(response.data.data[0]);

          this.$hideLoading();
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    openFileUpload(status) {
      this.isComment = status;
      document.getElementById("commentFileUpload").click();
    },
    toggleMore(evt) {
      let field = evt.target
        .closest(".more-btn-parent-div")
        .querySelector(".more_box");
      if (field.style.display === "none") {
        field.style.display = "block";
      } else {
        field.style.display = "none";
      }
    },
    setDetail() {
      this.$showLoading();
      socialApi
        .socialDetails(this.$route.params.postId)
        .then((response) => {
          this.detail = response.data.data;
          this.$hideLoading();
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    patchLikeState(id, status) {
      this.$showLoading();

      let action = status
        ? socialApi.patchPostLike("SNS", id)
        : socialApi.patchPostDislike("SNS", id);

      action
        .then((response) => {
          this.$hideLoading();
          this.detail.like = !status;
          this.detail.likesCount = !status
            ? this.detail.likesCount + 1
            : this.detail.likesCount - 1;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    deletePost() {
      this.$showLoading();

      socialApi
        .deletePost("SNS", this.detail.id)
        .then((response) => {
          this.$hideLoading();
          this.$router.push('/forum/');
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    askForDelete() {
      this.$confirm({
        // title: this.$t('72'),   // 학습을 중단한 강의입니다.
        content: this.$t("1877"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), //'TODO-취소'
      })
        .then(() => {
          this.deletePost();
        })
        .catch(() => {});
    },
    askForReport(status) {
      if (status) return;

      this.$confirm({
        // title: this.$t('72'),   // 학습을 중단한 강의입니다.
        content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1451"), // 확인
        cancel: this.$t("1447"), //'TODO-취소'
      })
        .then(() => {
          this.reportPost();
        })
        .catch(() => {});
    },
    reportPost() {
      this.$showLoading();

      socialApi
        .reportPost("SNS", this.detail.id)
        .then((response) => {
          this.$hideLoading();
          this.detail.report = true;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    getComments($state) {
      let responseData = null;
      let params = {
        // sort: "id,desc",
        page: this.currentPage,
        size: 10,
      };

      if (this.totalPages >= this.currentPage) {
        this.$showLoading();
        socialApi
          .listComments(this.$route.params.postId, params)
          .then((response) => {
            responseData = response.data.data;
            _.map(responseData.content, (o) => {
              o.progressViewStatus = false;
            });

            this.comments = this.comments.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.comments.length) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }

            this.$hideLoading();
          })
          .catch((err) => {
            this.$hideLoading();
            $state.error();
          });
      } else {
        $state.complete();
      }
    },
    resetCommentForm() {
      this.form = {
        contents: null,
        images: [],
      };
    },
    submitComment() {
      if (!this.detail) return;

      this.$showLoading();
      socialApi
        .commentPost(this.detail.id, this.form)
        .then((resp) => {
          // reset comment form
          this.resetCommentForm();

          this.comments.push(resp.data.data);
          this.detail.commentCount = this.detail.commentCount + 1;
          this.$hideLoading();
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    likeComment(id, status) {
      this.$showLoading();

      let action = status
        ? socialApi.dislikeComment("SNS", this.detail.id, id)
        : socialApi.likeComment("SNS", this.detail.id, id);

      action
        .then((response) => {
          this.$hideLoading();
          // search comment
          for (let c in this.comments) {
            if (this.comments[c].id == id) {
              this.comments[c].likes = !status;
              this.comments[c].likesCount = !status
                ? this.comments[c].likesCount + 1
                : this.comments[c].likesCount - 1;
              return;
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    likeReply(replyId, replyStatus, id) {
      this.$showLoading();

      let action = replyStatus
        ? socialApi.dislikeComment("SNS", this.detail.id, replyId)
        : socialApi.likeComment("SNS", this.detail.id, replyId);

      action
        .then((response) => {
          this.$hideLoading();
          // search comment
          for (let c in this.comments) {
            if (this.comments[c].id == id) {
              // search for the reply in selected comment
              for (let r in this.comments[c].children) {
                if (this.comments[c].children[r].id == replyId) {
                  this.comments[c].children[r].likes = !replyStatus;
                  this.comments[c].children[r].likesCount = !replyStatus
                    ? this.comments[c].children[r].likesCount + 1
                    : this.comments[c].children[r].likesCount - 1;
                }
              }
              return;
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    deleteComment(id) {
      this.$showLoading();

      socialApi
        .deleteComment("SNS", this.detail.id, id)
        .then((response) => {
          this.$hideLoading();
          this.detail.commentCount = this.detail.commentCount - 1;
          // search comment
          for (let c in this.comments) {
            if (this.comments[c].id == id) {
              this.comments.splice(c, 1);
              return;
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    reportComment(id, status) {
      if (status) return;

      this.$showLoading();

      socialApi
        .reportComment("SNS", this.detail.id, id)
        .then((response) => {
          this.$hideLoading();
          if (this.comments[c].id == id) {
            this.comments[c].report = true;
            return;
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    toggleReply(commentId) {
      document
        .getElementById(`commentInput_${commentId}`)
        .classList.toggle("d-none");
    },
    fileDisply(data) {
      localStorage.setItem("socialFile", JSON.stringify(data));
      this.$router.push("/file-display");
    },
    setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
  },
};
</script>

<style scoped>
.remove-image-new{
  top: -16px;
    right: -16px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    background: var(--Iconinactive);
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid var(--DocumentWhite);
    color:var(--DocumentWhite);
    line-height: 0px;

}
html[dir="rtl"] .remove-image-new{
    left: -16px;
}
.reply_area {
  border: solid 1px #c8c8c8;
}
.d-none {
  display: none;
}
.box-absolute {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 20px;
}
html[dir="rtl"] .box-absolute {
  left: 0;
}

/* reset */

</style>